var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare06 = function SvgShare06(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 18.5V15q0-1.347.952-2.298a3.13 3.13 0 0 1 2.298-.952h11.377l-3.85 3.85 1.07 1.054L21.5 11l-5.654-5.654L14.777 6.4l3.85 3.85H7.25q-1.97 0-3.36 1.39T2.5 15v3.5z"
  })));
};
export default SvgShare06;